import { buildReducer } from '../../utils/redux/getReduxModuleByFeatureName';
import getConstantsByFeatureName from '../../utils/redux/getConstantsByFeatureName';
import getActionCreators from '../../utils/redux/getActionCreators';
import getActionHandlers from '../../utils/redux/getActionHandlers';
import getSelectorByFeatureName from '../../utils/redux/getSelectorByFeatureName';
import getCRUDSagas from '../../utils/redux/getCRUDSagas';
import { initialState } from '../../utils/redux/commonActionHandlers';
import Api from '../../utils/Api';


// Prefix MUST be unique per feature — getConstantsByFeatureName
// builds action types as `@${prefix}/...`, and getCRUDSagas takes
// `takeEvery(constants.LOAD_ITEMS_REQUEST, fetchItems)` per feature.
// When two features share a prefix every dispatch fires both sagas;
// see the regression that landed before this fix: visiting
// /english-test-types triggered applicant-documents'
// `Api.applicantDocuments.index` (which reads userId from
// `window.location.pathname.split('/')[2]`), GET /api/users/undefined/
// documents 404'd, and authorization/handleError pushed
// /page-not-found.
const constantsPrefix = 'ENGLISH-TEST-TYPES';
const statePropName = 'englishTestTypes';
const formStatePropName = 'englishTestTypes';
const mainPageUrl = '/english-test-types';

const constants = getConstantsByFeatureName(constantsPrefix);
const actions = getActionCreators(constants);
const actionHandlers = getActionHandlers(constants);
const reducer = buildReducer(initialState, actionHandlers);
const selector = getSelectorByFeatureName(statePropName);

const sagas = getCRUDSagas(
  mainPageUrl,
  Api.englishTestTypes,
  actions,
  constants,
  formStatePropName,
  statePropName,
  { itemName: 'English Test Types' },
);

export { constants, actions, reducer, selector, sagas };
